import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../../api/api";
import { IWheelOfFortuneGameState, WheelOfFortunePrizesByMode } from ".";

export interface IWheeOfFortuneGetInfoResponse {
    freeSpinsCount: number;
    nextResetTime: number;
    wheel: WheelOfFortunePrizesByMode | null;
    costs: Record<number, number> | null;
};

export const wheelOfFortuneGetInfo = createAsyncThunk<IWheeOfFortuneGetInfoResponse>(
    'game/wheel-of-fortune/get-info',
    async () => await api.games.wheelOfFortune.getInfo()
);

const wheelOfFortuneGetInfoHandler = (builder: ActionReducerMapBuilder<IWheelOfFortuneGameState>) => {
    builder
        .addCase(wheelOfFortuneGetInfo.pending, (state: IWheelOfFortuneGameState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(wheelOfFortuneGetInfo.fulfilled, (state: IWheelOfFortuneGameState, action: PayloadAction<IWheeOfFortuneGetInfoResponse>) => {
            state.loading = false;

            if (!action.payload)
                return;

            state.freeSpinsCount = action.payload.freeSpinsCount;
            state.costs = action.payload.costs;
            state.wheel = action.payload.wheel;
            state.nextResetTime = action.payload.nextResetTime;
        })
        .addCase(wheelOfFortuneGetInfo.rejected, (state: IWheelOfFortuneGameState) => {
            state.loading = false;
            state.error = 'Unable to get wheel of fortune info';
        });
};

export default wheelOfFortuneGetInfoHandler;